export const range = (start: number, stop: number) =>
  Array.from({ length: stop - start + 1 }, (_, i) => start + i);

export const formatMoney = (amount: number | string, currency: string, locale: string): string => {
  const localeToUse = ['de-AT', 'de-CH'].includes(locale)
    ? 'de-DE'
    : ['it-IT'].includes(locale)
      ? 'de-AT'
      : ['da-DK'].includes(locale)
        ? 'nb-NO'
        : locale;
  const currencyToUse = locale === 'ro-RO' ? 'LEI' : locale === 'da-DK' ? 'NOK' : currency;
  const formatter = new Intl.NumberFormat(localeToUse, {
    style: 'currency',
    currency: currencyToUse,
  });
  return formatter.format(typeof amount === 'string' ? parseFloat(amount) : amount);
};
